webpackJsonp([213534597649335],{

/***/ 340:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/favicon.aaf48f6a.ico";

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(16);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _moment = __webpack_require__(76);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Post = function (_React$Component) {
	  _inherits(Post, _React$Component);
	
	  function Post() {
	    _classCallCheck(this, Post);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Post.prototype.render = function render() {
	    var _props$data$node$fron = this.props.data.node.frontmatter,
	        title = _props$data$node$fron.title,
	        date = _props$data$node$fron.date,
	        category = _props$data$node$fron.category,
	        description = _props$data$node$fron.description;
	    var _props$data$node$fiel = this.props.data.node.fields,
	        slug = _props$data$node$fiel.slug,
	        categorySlug = _props$data$node$fiel.categorySlug;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'post' },
	      _react2.default.createElement(
	        'div',
	        { className: 'post__meta' },
	        _react2.default.createElement(
	          'time',
	          { className: 'post__meta-time', dateTime: (0, _moment2.default)(date).format('MMMM D, YYYY') },
	          (0, _moment2.default)(date).format('MMMM YYYY')
	        ),
	        _react2.default.createElement('span', { className: 'post__meta-divider' }),
	        _react2.default.createElement(
	          'span',
	          { className: 'post__meta-category', key: categorySlug },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: categorySlug, className: 'post__meta-category-link' },
	            category
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'h2',
	        { className: 'post__title' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: 'post__title-link', to: slug },
	          title
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'post__description' },
	        description
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { className: 'post__readmore', to: slug },
	        'Read'
	      )
	    );
	  };
	
	  return Post;
	}(_react2.default.Component);
	
	exports.default = Post;
	module.exports = exports['default'];

/***/ }),

/***/ 54:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(23);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Post = __webpack_require__(44);
	
	var _Post2 = _interopRequireDefault(_Post);
	
	var _Sidebar = __webpack_require__(24);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _favicon = __webpack_require__(340);
	
	var _favicon2 = _interopRequireDefault(_favicon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndexRoute = function (_React$Component) {
	  _inherits(IndexRoute, _React$Component);
	
	  function IndexRoute() {
	    _classCallCheck(this, IndexRoute);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  IndexRoute.prototype.render = function render() {
	    var items = [];
	    var _props$data$site$site = this.props.data.site.siteMetadata,
	        title = _props$data$site$site.title,
	        subtitle = _props$data$site$site.subtitle;
	
	    var posts = this.props.data.allMarkdownRemark.edges;
	    posts.forEach(function (post) {
	      items.push(_react2.default.createElement(_Post2.default, { data: post, key: post.node.fields.slug }));
	    });
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          title
	        ),
	        _react2.default.createElement('link', { rel: 'shortcut icon', href: _favicon2.default }),
	        _react2.default.createElement('meta', { name: 'description', content: subtitle }),
	        _react2.default.createElement('meta', { name: 'google-site-verification', content: '21ydIzFxx12lKL62LdIRDejxmE4jXIcK5zqnfYqBKx4' })
	      ),
	      _react2.default.createElement(_Sidebar2.default, this.props),
	      _react2.default.createElement(
	        'div',
	        { className: 'content' },
	        _react2.default.createElement(
	          'div',
	          { className: 'content__inner' },
	          items
	        )
	      )
	    );
	  };
	
	  return IndexRoute;
	}(_react2.default.Component);
	
	exports.default = IndexRoute;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-jsx-97b1ff799dd8f3ed062a.js